import { useEffect, useState } from "react";
import { LogOut, UserRoundCog } from "lucide-react";
import { useAuth } from "@/features/auth/hooks/useAuth";

const formatRemainingTime = (ms: number): string => {
  if (ms <= 0) return "expirée";
  const minutes = Math.floor(ms / 60000);
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h${remainingMinutes.toString().padStart(2, "0")}`;
  }
  return `${minutes}min`;
};

export const ImpersonationBanner = () => {
  const { user, logout } = useAuth();
  const impersonation = user?.employee?.impersonation;
  const [remainingTime, setRemainingTime] = useState(0);

  useEffect(() => {
    if (!impersonation?.session_expires_at) return;

    const update = () => {
      const expiresAt = new Date(impersonation.session_expires_at).getTime();
      setRemainingTime(Math.max(0, expiresAt - Date.now()));
    };

    update();
    const interval = setInterval(update, 30_000);
    return () => clearInterval(interval);
  }, [impersonation?.session_expires_at]);

  if (!impersonation?.active) return null;

  return (
    <div className="bg-amber-500 text-black px-4 py-2 flex items-center justify-between sticky top-0 z-[51]">
      <div className="flex items-center gap-2">
        <UserRoundCog className="h-4 w-4" />
        <span>
          Session d&apos;impersonation
          {impersonation.issued_by_name && (
            <span className="ml-1 text-amber-900">
              (par
              {" "}
              {impersonation.issued_by_name}
              )
            </span>
          )}
        </span>
        <span className="ml-2 text-amber-800 text-sm">
          - Expire dans
          {" "}
          {formatRemainingTime(remainingTime)}
        </span>
      </div>
      <button
        type="button"
        onClick={() => logout()}
        className="flex items-center gap-2 px-3 py-1 text-sm font-medium bg-white hover:bg-gray-100 rounded-md border border-gray-300 cursor-pointer"
      >
        <LogOut className="h-4 w-4" />
        Se déconnecter
      </button>
    </div>
  );
};
